<template>
      <mw-dialog  size="large_small" title="任务列表" :footerButton="footerButton" ref="dialog">
      <div style="padding: 10px;height:100%;">
        <el-table
          :data="unfinishedTaskQueue"
          height="100%"
        >
          <el-table-column prop="name" label="任务名称"/>
          <el-table-column prop="createTime" label="创建时间"/>
          <el-table-column prop="sender" label="发送人"/>
          <el-table-column prop="assigneeName" label="办理人" :formatter="assigneeNameFormatter"/>
          <el-table-column prop="claimTime" label="签收时间"/>
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="60">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="forceWithdraw(scope.$index, scope.row)"
                type="text"
                size="small">
                回收
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </mw-dialog>
</template>

<script>
import api from "@/common/api/maintain";
export default {
  data() {
    return {
      footerButton: [
        {
          label: "取消",
          func: () => this.mwRef("dialog").hide()
        }
      ],
      businessId: '',
      batchId:'',
      unfinishedTaskQueue: []
    };
  },

  methods: {
    assigneeNameFormatter:function(a, b, c){
        if(a.assigneeName){
            return a.assigneeName;
        }else{
            return a.candidateName;
        }
    },
    async action({ applicationId, businessId, batchId, moduleId }) {
      this.mwRef("dialog").show();
      this.businessId = businessId;
      this.batchId = batchId;
      this.getUnfinishedTaskQueue();
    },
    async getUnfinishedTaskQueue() {
      this.unfinishedTaskQueue = [];
      this.unfinishedTaskQueue =
        (await api.listUnfinishedTask(this.batchId, { type: 1, unfinished:true, undrafted:true })).result ||
        [];
    },

    async forceWithdraw(index, row) {
      if ((await this.mwConfirm('回收'))) {
        const {success} = await api.deleteTask(row.id, {});
        if (success) {
          this.mwMsg('回收成功');
          this.$emit('updateTable');
          this.mwRef("dialog").hide();
        }
      }

    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/forceWithdraw.vue